import { atom } from 'jotai';

const redirectToCCModal_DEFAULT = {
  show: false,
};

export type AppUIState = {
  redirectToCCModal: {
    show: boolean;
    title?: {
      value?: string;
      translateKey?: string;
    };
    body?: {
      value?: string;
      translateKey?: string;
    };
  };
};

const initialState: AppUIState = {
  redirectToCCModal: redirectToCCModal_DEFAULT,
};

export const appUIAtom = atom<AppUIState>(initialState);
